(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-pet-tabs]').forEach(group => {
      if (group.dataset.tabsReady) return;
      group.dataset.tabsReady = 'true';
      const tabs = [...group.querySelectorAll('[role="tab"]')];
      const select = tab => tabs.forEach(item => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1;
        const panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          select(tabs[next]); tabs[next].focus();
        });
      });
    });
  };
  init(); document.addEventListener('shopify:section:load', e => init(e.target));
  let timer;
  const cancelPendingUpdate = () => { clearTimeout(timer); timer = undefined; };
  document.addEventListener('submit', event => { if (event.target.id === 'CartForm') cancelPendingUpdate(); });
  window.addEventListener('pagehide', cancelPendingUpdate);
  document.addEventListener('change', event => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.name !== 'updates[]') return;
      const cart = input.closest('#CartForm');
      if (!cart) return;
      cancelPendingUpdate();
      if (!input.checkValidity()) return;
      timer = setTimeout(() => {
        timer = undefined;
        const status = document.getElementById('CartUpdateStatus'); if (status) status.textContent = 'Updating your cart…';
        cart.requestSubmit(cart.querySelector('[name="update"]'));
      }, 450);
  });
})();
